export const pipelineCandidateId = row => String(row.candidate_id ?? row.id);

export async function loadAllPipelineCandidates(request, apiBase, filters = {}) {
  const rows = new Map();
  let received = 0;
  for (let page = 1; ; page += 1) {
    const query = new URLSearchParams({ ...filters, has_job: "1", page: String(page), limit: "1000" });
    const response = await request(`${apiBase}/api/candidates?${query}`);
    if (!response.ok) throw new Error("Could not select all candidates. Please try again.");
    const payload = await response.json();
    const batch = payload.rows || payload.candidates || payload.data || [];
    const previousSize = rows.size;
    batch.forEach(row => rows.set(pipelineCandidateId(row), row));
    received += batch.length;
    if (received >= Number(payload.total) || (!Number.isFinite(Number(payload.total)) && batch.length < 1000)) break;
    if (!batch.length || rows.size === previousSize) throw new Error("The candidate list changed. Please try selecting all again.");
  }
  return [...rows.values()];
}

// Update the job association displayed by the pipeline, not the separate profile stage.
export async function movePipelineCandidates(request, apiBase, rows, stage, rejection = {}) {
  const groups = new Map();
  const failedIds = new Set();
  const updatedIds = new Set();
  for (const row of rows) {
    const id = pipelineCandidateId(row);
    if (!row.job_id) { failedIds.add(id); continue; }
    const key = String(row.job_id);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(id);
  }
  // Bounded batches avoid flooding the server for large Source-stage uploads.
  for (const [jobId, ids] of groups) {
    for (let offset = 0; offset < ids.length; offset += 100) {
      const batch = ids.slice(offset, offset + 100);
      try {
        const response = await request(`${apiBase}/api/jobs/${encodeURIComponent(jobId)}/matches/stage`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ candidate_ids: batch, stage, ...rejection }),
        });
        if (!response.ok) throw new Error("Stage update failed");
        const payload = await response.json();
        const changed = new Set((payload.updated_candidate_ids || []).map(String));
        batch.forEach(id => (changed.has(id) ? updatedIds : failedIds).add(id));
      } catch {
        batch.forEach(id => failedIds.add(id));
      }
    }
  }
  return { updatedIds, failedIds };
}
